import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../firebase/UserProvider';
import { useAdmin } from '../context/AdminContext';
import LoadingSpiner from '../LoadingSpiner';

const AdminRoute = ({ children }) => {
  const { user, loading: userLoading } = useUser();
  const { isAdmin, loading: adminLoading, checkAdminForUser } = useAdmin();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (user && user.uid) {
      const unsubscribe = checkAdminForUser(user.uid);
      setInitialized(true);
      return () => {
        if (unsubscribe) unsubscribe();
      };
    } else if (!user && !userLoading) {
      setInitialized(true);
    }
  }, [user, userLoading, checkAdminForUser]);

  if (userLoading || adminLoading || !initialized) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <LoadingSpiner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
